import { useEffect, useState } from 'react'
import { mapValueToDashOffset } from '../utils/mapValueToDashOffset'

export type ScoreProps = {
  value: number
}

export function Score(props: ScoreProps) {
  const [value, setValue] = useState(0)

  useEffect(() => {
    setTimeout(() => {
      setValue(props.value)
    }, 5)
  }, [props.value])

  return (
    <div className='score'>
      <div className='score-number'>{value || '--'}</div>
      <svg
        xmlns='https://www.w3.org/2000/svg'
        version='1.1'
        width='200px'
        height='200px'
        className='svg-track'
      >
        <circle cx='100' cy='100' r='70' strokeLinecap='round' />
      </svg>
      <svg
        xmlns='https://www.w3.org/2000/svg'
        version='1.1'
        width='200px'
        height='200px'
        className='svg-score'
      >
        <circle
          cx='100'
          cy='100'
          r='70'
          stroke={value >= 50 ? '#09cca9' : '#CC0066'}
          strokeLinecap='round'
          strokeDasharray='450'
          strokeDashoffset={mapValueToDashOffset(value)}
        />
      </svg>
    </div>
  )
}
